<template>
    <div class="flex flex-grow flex-col relative">
      <vue-progress-bar></vue-progress-bar>
      <div class="w-full max-w-screen-xl flex flex-grow flex-col lg:mx-auto z-20">

        <div class="row flex">
          <div class="w-full lg:w-1/2 mx-auto text-center mt-4">
            <h1 class="mb-1">Checkout</h1>
            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque congue quam ac consequat tincidunt. Sed sed dictum purus.</p> -->
          </div>
        </div>

        <!-- Product summary start -->
        <div class="container mx-auto flex lg:flex-grow flex-wrap">
          <div id="summary" class="w-full lg:order-last lg:w-2/5 border-t border-b lg:border-t-0 lg:border-b-0 border-primary">
            <template v-if="loaded">

              <!-- Summary mobile -->
              <div class="lg:hidden">
                <div class="flex items-center text-lg p-1">
                  <div class="flex-grow hover:text-primary-800 hover:cursor-pointer" @click="expanded = !expanded">
                    <base-icon class="text-primary" :icon="['fas', 'shopping-cart']"></base-icon>
                    <span class="pl-1 pr-1">Show full order</span>
                    <base-icon :icon="['fas', 'chevron-down']"></base-icon>
                  </div>
                  <h4 class="font-base text-grey mb-0">{{ $store.state.basket.formatted_total }}</h4>
                </div>
                <div v-if="expanded" class="border-t border-primary">
                  <div class="p-1">
                    <h2 class="mb-1 antialised text-grey font-normal">My Order</h2>
                    <div
                      v-for="(product) in $store.state.basket.products"
                    >
                    <div class="flex items-center mb-1">
                      <div class="w-4 h-4 relative flex-shrink-0">
                        <div class="w-4 h-4 flex items-center justify-center bg-white shadow-md overflow-hidden">
                          <img v-if="product.product.image_id" class="w-4 h-4 height-auto" width="64" height="64" :src="product.product.image.thumbnail">
                          <base-icon v-else class="text-2xl text-grey" :icon="['fas', 'image']"></base-icon>
                        </div>
                        <span class="absolute top-0 right-0 w-1 h-1 flex items-center justify-center rounded-md text-sm text-white bg-primary shadow-sm">{{ product.quantity }}</span>
                      </div>
                      <div class="flex-grow px-1">
                        <p class="text-grey">{{ product.product.name }}</p>
                        <template v-if="product.product_variant_id">
                          <span
                            v-for="{ name } in product.product_variant.attributes"
                            class="text-grey text-sm"
                          >{{ name }}, </span>
                        </template>
                      </div>
                      <div class="text-right text-grey">
                        {{ product.formatted_subtotal }}
                      </div>
                    </div>
                      <hr class="border-primary py-1">
                    </div>

                    <div class="py-1">
                      <div class="flex items-end justify-between mb-1">
                        <span class="text-grey">Subtotal</span>
                        <span class="text-grey">{{ $store.state.basket.formatted_subtotal }}</span>
                      </div>
                      <div class="flex items-end justify-between mb-1">
                        <span class="text-grey">VAT</span>
                        <span class="text-grey">{{ $store.state.basket.formatted_tax }}</span>
                      </div>
                      <div class="flex items-end justify-between">
                        <span class="text-grey">Delivery</span>
                        <span class="text-grey" :class="{ 'text-sm': !$store.state.basket.formatted_shipping_amount }">{{ $store.state.basket.formatted_shipping_amount || 'Calculated at next step' }}</span>
                      </div>
                    </div>

                    <hr class="border-primary">

                    <div class="flex items-center justify-between pt-1 text-lg">
                      Total
                      <p class="text-xl font-semibold text-grey-dark mb-0">{{ $store.state.basket.formatted_total }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- summary dekstop start -->
              <div class="hidden lg:block py-1 lg:py-2">

                <h2 class="mb-1 pb-1 border-b-2 border-primary antialised font-light text-xl md:text-xl lg:text-3xl">My Order</h2>

                <div
                  v-for="(product) in $store.state.basket.products"
                >
                <div class="flex items-center mb-1">
                  <div class="w-8 h-8 relative flex-shrink-0">
                    <div class="w-8 h-8 flex items-center justify-center bg-white  overflow-hidden shadow-md">
                      <img v-if="product.product.image_id && product.product.image.thumbnail" class="w-8 h-8 height-auto" width="128" height="128" :src="product.product.image.thumbnail">
                      <img v-else-if="product.product.image_id && product.product.image.url" alt="" class="w-8 h-8 height-auto" width="128" height="128" :src="product.product.image.url">
                      <base-icon v-else class="text-xl text-grey" :icon="['fas', 'image']"></base-icon>
                    </div>
                    <span class="absolute top-0 right-0 transform w-2 h-2 flex items-center justify-center rounded-md text-sm bg-primary text-white shadow-sm">{{ product.quantity }}</span>
                  </div>
                  <div class="flex-grow px-1">
                    <p class="text-grey text-med font-base">{{ product.product.name }}</p>
                    <template v-if="product.product_variant_id">
                      <span
                        v-for="{ name } in product.product_variant.attributes"
                        class="text-grey text-xs"
                      >{{ name }}, </span>
                    </template>
                  </div>
                  <div class="text-right text-grey">
                    {{ product.formatted_subtotal }}
                  </div>
                </div>

                  <hr class="border-primary pt-1">
                </div>

                <div class="py-1">
                  <div class="flex items-end justify-between mb-1">
                    <span class="text-grey text-sm">Subtotal</span>
                    <span class="text-grey">{{ $store.state.basket.formatted_subtotal }}</span>
                  </div>
                  <div class="flex items-end justify-between mb-1">
                    <span class="text-grey text-sm">Tax</span>
                    <span class="text-grey">{{ $store.state.basket.formatted_tax }}</span>
                  </div>
                  <div class="flex items-end justify-between">
                    <span class="text-grey text-sm">Delivery</span>
                    <span class="text-grey" :class="{ 'text-sm': !$store.state.basket.formatted_shipping_amount }">{{ $store.state.basket.formatted_shipping_amount || 'Calculated at next step' }}</span>
                  </div>
                </div>

                <hr class="border-primary">

                <div class="py-1">
                  <div class="flex items-center justify-between">
                    <span class="text-lg text-grey-dark">Total</span>
                    <span class="text-xl text-grey-dark font-semibold">{{ $store.state.basket.formatted_total }}</span>
                  </div>
                </div>

              </div>

            </template>
          </div>
          <!-- Product summary end -->

          <div id="checkout" class="w-full lg:order-first lg:w-3/5 pb-2 px-2 lg:px-3">

            <!-- shipping step start -->
            <div class="bg-primary px-2 py-2 lg:px-4 lg:py-3 border-r-2 border-grey-dark" v-show="step === 'shipping'">
              <h2 class="mb-1 antialised font-light text-white text-lg md:text-xl lg:text-2xl">My Details</h2>

              <form @submit.prevent="submit">
                <div class="flex flex-wrap -mx-1">

                  <div class="w-full lg:w-1/2 px-1 mb-2">
                    <input
                      id="shipping_first_name"
                      type="text"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="First Name"
                      v-model="shipping.first_name"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.shipping.hasOwnProperty('first_name')">{{ errors.shipping.first_name[0] }}</div>
                  </div>

                  <div class="w-full lg:w-1/2 px-1 mb-2">
                    <input
                      id="shipping_last_name"
                      type="text"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Last Name"
                      v-model="shipping.last_name"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.shipping.hasOwnProperty('last_name')">{{ errors.shipping.last_name[0] }}</div>
                  </div>

                  <div class="w-full lg:w-1/2 px-1 mb-2">
                    <input
                      id="email"
                      type="email"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Email"
                      v-model="shipping.email"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.shipping.hasOwnProperty('email')">{{ errors.shipping.email[0] }}</div>
                  </div>

                  <div class="w-full lg:w-1/2 px-1 mb-2">
                    <input
                      id="phone"
                      type="text"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Phone"
                      v-model="shipping.phone"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.shipping.phone">{{ errors.shipping.phone[0] }}</div>
                  </div>

                  <div class="w-full lg:w-1/2 px-1 mb-2">
                    <input
                      id="shipping_company_name"
                      type="text"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm"
                      v-model="shipping.company_name" placeholder="Company Name (optional)"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.shipping.hasOwnProperty('company_name')">{{ errors.shipping.company_name[0] }}</div>
                  </div>

                  <div class="w-full lg:w-1/2 px-1 mb-2">
                    <input
                      id="shipping_address_2"
                      type="text"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Flat number, building name etc.(optional)"
                      v-model="shipping.address_2"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.shipping.hasOwnProperty('address_2')">{{ errors.shipping.address_2[0] }}</div>
                  </div>

                  <div class="w-full lg:w-1/2 px-1 mb-2">
                    <input
                      id="shipping_address_1"
                      type="text"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Address"
                      v-model="shipping.address_1"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.shipping.hasOwnProperty('address_1')">{{ errors.shipping.address_1[0] }}</div>
                  </div>

                  <div class="w-full lg:w-1/2 px-1 mb-2">
                    <input
                      id="shipping_city"
                      type="text"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="City"
                      v-model="shipping.city"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.shipping.hasOwnProperty('city')">{{ errors.shipping.city[0] }}</div>
                  </div>

                  <div class="w-full lg:w-1/2 px-1 mb-2">
                    <input
                      id="shipping_state"
                      type="text"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="County"
                      v-model="shipping.state"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.shipping.hasOwnProperty('state')">{{ errors.shipping.state[0] }}</div>
                  </div>

                  <div class="w-full lg:w-1/2 px-1 mb-2">
                    <select
                      id="shipping_country"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Country"
                      v-model="shipping.country"
                    >
                      <option v-for="{ code, name } in $store.state.countries" :value="code">{{ name }}</option>
                    </select>
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.shipping.hasOwnProperty('country')">{{ errors.shipping.country[0] }}</div>
                  </div>

                   <div class="w-full lg:w-1/2 px-1 mb-2">
                    <input
                      id="shipping_postcode"
                      type="text"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm"
                      v-model="shipping.postcode" placeholder="Postcode"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.shipping.hasOwnProperty('postcode')">{{ errors.shipping.postcode[0] }}</div>
                  </div>
                </div>

                <div class="my-1">
<!--                   <h5 class="mb-1">Fulfilment Method</h5> -->

                <!-- <label class="checkbox-wrap"><small>Delivery</small> -->
                      <input class="mb-0 mr-3" value="ship" type="hidden" v-model="shipping.fulfilment_method">
                   <!--    <span class="checkmark"></span>
                  </label> -->
<!--
                  <label class="checkbox-wrap"><small>Collection in Store</small>
                      <input class="mb-0 mr-3" value="collection" type="radio" v-model="shipping.fulfilment_method">
                      <span class="checkmark"></span>
                  </label> -->
                </div>

                <div v-if="error" class="bg-red-100 border border-red-300 text-sm text-red-700 mb-4 px-4 py-3 rounded relative" role="alert">
                  {{ error }}
                </div>

                <div class="text-right">
                  <button
                    type="submit"
                    class="btn disabled:bg-primary text-white  disabled:border-primary-900 focus:outline-none tracking-widest border border-white"
                    :disabled="submitting"
                  >
                    Continue
                  </button>
                </div>
              </form>
            </div>
            <!-- shipping step end -->


            <!-- billing step start -->
            <div class="bg-primary px-2 py-2 lg:px-4 lg:py-3 border-r-2 border-grey-dark" v-show="step === 'billing'">
              <h2 class="mb-1 antialised font-light text-white text-lg md:text-xl lg:text-2xl">Billing</h2>

              <form @submit.prevent="submit">

                <div class="my-2">

                  <label class="checkbox-wrap block">
                    <small class="font-base text-white">Billing address the same as shipping address</small>
                      <input class="mb-0 mr-3" type="radio" value="same" v-model="billing.address_option">
                      <span class="checkmark"></span>
                  </label>

                  <label class="checkbox-wrap block">
                    <small class="font-base text-white">Billing address different from shipping address</small>
                      <input class="mb-0 mr-3" type="radio" value="different" v-model="billing.address_option">
                      <span class="checkmark"></span>
                  </label>
                </div>

                <template v-if="billing.address_option === 'different'">
                  <div class="flex flex-wrap -mx-1">

                    <div class="w-full lg:w-1/2 px-1 mb-2">
                      <input
                        id="billing_name"
                        type="text"
                        class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Name"
                        v-model="billing.name"
                      >
                      <div class="mt-1 text-xs text-red font-bold" v-if="errors.billing.hasOwnProperty('name')">{{ errors.billing.name[0] }}</div>
                    </div>

                    <div class="w-full lg:w-1/2 px-1 mb-2">
                      <input
                        id="billing_company_name"
                        type="text"
                        class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm"
                        v-model="billing.company_name" placeholder="Company Name (optional)"
                      >
                      <div class="mt-1 text-xs text-red font-bold" v-if="errors.billing.hasOwnProperty('company_name')">{{ errors.billing.company_name[0] }}</div>
                    </div>

                    <div class="w-full lg:w-1/2 px-1 mb-2">
                      <input
                        id="billing_address_1"
                        type="text"
                        class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm"
                        v-model="billing.address_1" placeholder="Address"
                      >
                      <div class="mt-1 text-xs text-red font-bold" v-if="errors.billing.hasOwnProperty('address_1')">{{ errors.billing.address_1[0] }}</div>
                    </div>

                    <div class="w-full lg:w-1/2 px-1 mb-2">
                      <input
                        id="billing_address_2"
                        type="text"
                        class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Flat number, building name etc. (optional)"
                        v-model="billing.address_2"
                      >
                      <div class="mt-1 text-xs text-red font-bold" v-if="errors.billing.hasOwnProperty('address_2')">{{ errors.billing.address_2[0] }}</div>
                    </div>

                    <div class="w-full lg:w-1/2 px-1 mb-2">
                      <input
                        id="billing_city"
                        type="text"
                        class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="City"
                        v-model="billing.city"
                      >
                      <div class="mt-1 text-xs text-red font-bold" v-if="errors.billing.hasOwnProperty('city')">{{ errors.billing.city[0] }}</div>
                    </div>

                    <div class="w-full lg:w-1/2 px-1 mb-2">
                      <input
                        id="billing_state"
                        type="text"
                        class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm"
                        v-model="billing.state" placeholder="County"
                      >
                      <div class="mt-1 text-xs text-red font-bold" v-if="errors.billing.hasOwnProperty('state')">{{ errors.billing.state[0] }}</div>
                    </div>

                    <div class="w-full lg:w-1/2 px-1 mb-2">
                      <select
                        id="billing_country"
                        class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm"
                        v-model="billing.country" placeholder="Country"
                      >
                        <option v-for="{ code, name } in $store.state.countries" :value="code">{{ name }}</option>
                      </select>
                      <div class="mt-1 text-xs text-red font-bold" v-if="errors.billing.hasOwnProperty('country')">{{ errors.billing.country[0] }}</div>
                    </div>

                    <div class="w-full lg:w-1/2 px-1 mb-2">
                        <input
                          id="billing_postcode"
                          type="text"
                          class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm"
                          v-model="billing.postcode" placeholder="Postcode"
                        >
                        <div class="mt-1 text-xs text-red font-bold" v-if="errors.billing.hasOwnProperty('postcode')">{{ errors.billing.postcode[0] }}</div>
                    </div>

                  </div>
                </template>

                <div v-if="error" class="bg-red-100 border border-red-300 text-sm text-red-700 mb-1 px-4 py-3 rounded relative" role="alert">
                  {{ error }}
                </div>

                <div class="text-right">
                  <button
                    type="submit"
                    class="btn disabled:bg-primary text-white  disabled:border-primary-900 focus:outline-none tracking-widest border border-white"
                    :disabled="submitting"
                  >
                    Proceed to Payment by Card
                  </button>
                </div>

              </form>
            </div>
            <!-- Billing End -->

            <!-- Payment start -->
            <div class="bg-primary px-2 py-2 lg:px-4 lg:py-3 border-r-2 border-grey-dark" v-show="step === 'payment'">
              <h2 class="mb-1 antialised font-light text-white text-lg md:text-xl lg:text-2xl">Payment</h2>

                <div class="flex flex-wrap -mx-1">

                  <div class="w-full px-1 mb-2">
                    <input
                      id="card_number"
                      type="tel"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Card Number"
                      v-model="cardData.cardNumber"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.cardData.hasOwnProperty('cardNumber')">{{ errors.cardData.cardNumber }}</div>
                  </div>

                  <div class="w-full lg:w-1/2 px-1 mb-2">
                    <div class="flex flex-wrap -mx-1">
                      <div class="w-full lg:w-1/2 px-1">
                          <input
                            id="expiry_date_month"
                            type="number"
                            maxlength="2"
                            class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Expiry Month Date (mm)"
                            v-model="cardData.expiryDateMonth"
                          >
                      </div>
                      <div class="w-full lg:w-1/2 px-1">
                          <input
                            id="expiry_date_year"
                            type="number"
                            maxlength="2"
                            class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Expiry Year Date (yy)"
                            v-model="cardData.expiryDateYear"
                          >
                      </div>
                      <div class="w-full mb-2 px-1">
                        <div class="mt-1 text-xs text-red font-bold" v-if="errors.cardData.hasOwnProperty('expiryDate')">{{ errors.cardData.expiryDate }}</div>
                      </div>
                    </div>

                  </div>

<!--                   <div class="w-full lg:w-1/2 px-1 mb-2">
                    <input
                      id="expiry_date_year"
                      type="text"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Expiry Date Year (yy)"
                      v-model="cardData.expiryDateYear"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.cardData.hasOwnProperty('expiryDateYear')">{{ errors.cardData.expiryDateYear }}</div>
                  </div> -->

                  <div class="w-full lg:w-1/2 px-1 mb-2">
                    <input
                      id="Cvn"
                      type="tel"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="Security Code"
                      v-model="cardData.Cvn"
                    >
                    <div class="mt-1 text-xs text-red font-bold" v-if="errors.cardData.hasOwnProperty('Cvn')">{{ errors.cardData.Cvn }}</div>
                  </div>

                  <div class="w-full px-1 mb-2">
                    <input
                      id="card_name"
                      type="text"
                      class="appearance-none bg-white w-full py-1 px-1 text-sm text-grey focus:outline-none focus:shadow-outline shadow-sm" placeholder="CardHolder Name"
                      v-model="cardData.cardName"
                    >
                     <div class="mt-1 text-xs text-red font-bold" v-if="errors.cardData.hasOwnProperty('cardName')">{{ errors.cardData.cardName }}</div>
                  </div>

                </div>


                <div v-if="error" class="bg-red-100 border border-red-300 text-sm text-red-700 mb-4 px-4 py-3 rounded relative text-white" role="alert">
                  {{ error }}
                </div>

                <div class="text-right">
                  <button
                    id="payment-button"
                    type="button"
                    class="btn btn-primary disabled:bg-primary-800 border border-white text-white disabled:opacity-50 focus:outline-none tracking-widest"
                    :disabled="submitting"
                    @click="validatePayment"
                  >
                  <span v-if="submitting">
                    <base-icon class="text-xs mr-2 fa-spin" :icon="['fas', 'spinner']"></base-icon>
                  </span>
                    Confirm Payment of {{ $store.state.basket.formatted_total }}
                  </button>

                </div>

            </div>

            <div class="bg-white px-6 py-6" v-show="step === 'review'">
            <div class="flex-col flex items-center justify-center">
              <div class="w-3 h-3 rounded-full border-2 border-green m-1 flex items-center justify-center"><base-icon class="text-green" :icon="['fas','check']"></base-icon></div>

              <h2 class="mb-3 text-2xl">Thank you!</h2>

              <div v-if="success" class="bg-green-100 text-green-700 mb-4 px-4 py-3 rounded relative" role="alert">
                {{ success }}
              </div>
              </div>
            </div>



          </div>
        </div>
      </div>

    </div>
</template>


<script>

  export default {
    data () {
      return {
        basketId: null,
        card: null,
        loaded: false,
        complete: false,
        expanded: false,
        submitting: false,
        step: 'shipping',
        intentData: {},
        steps: {
          shipping: false,
          billing: false,
          payment: false
        },
        shipping: {
          fulfilment_method: 'ship'
        },
        billing: {
          address_option: 'same'
        },
        success: null,
        error: null,
        cardData: {
          basketId: null,
          cardName: null,
          cardNumber: null,
          expiryDateMonth: null,
          expiryDateYear: null,
          expiryDate: null,
          Cvn: null,
        },
        cardValidationPassed: false,
        errors: {
          shipping: {},
          billing: {},
          cardData: {}
        },
        api_uri: 'https://api.justdoorsandconservatories.co.uk',
      }
    },
    mounted() {
      this.basketId = parseInt(sessionStorage.getItem('basket-id'));
      this.shipping.basketid = this.basketId
      this.billing.basketid = this.basketId
      this.cardData.basketId = this.basketId

      if(this.basketId == undefined || this.basketId == null || isNaN(this.basketId)) {
        window.location.href = "/";
      }

      axios.interceptors.response.use(response => {
        return response
      }, (error) => {
        if (error.response.status === 401) {
          location.reload()
        }

        if (error.response.status === 419) {
          location.reload()
        }

        return Promise.reject(error)
      })
      axios.get(this.api_uri + '/checkout?basketid=' + this.basketId)
        .then(response => {
          this.$Progress.finish()
          this.loaded = true
          this.$store.commit('basket', response.data.basket)
          this.$store.commit('countries', response.data.countries)
          this.$store.commit('customer', {})

          if (this.$store.state.basket.products_count === 0) {
            location.assign('/')
          }
        })
    },
    created () {
      this.$Progress.start()
      this.$router.beforeEach((to, from, next) => {
        if (to.meta.progress !== undefined) {
          let meta = to.meta.progress
          this.$Progress.parseMeta(meta)
        }
        this.$Progress.start()
        next()
      })
    },
    methods: {
      submit () {
        let data = {
          shipping: this.shipping,
          billing: this.billing.address_option === 'same' ? this.shipping : this.billing
        }

        this.submitting = true

        axios.post(this.api_uri + '/checkout/' + this.step, data[this.step])
          .then(response => {
            this.submitting = false
            this.error = null
            this.errors[this.step] = {}

            switch (this.step) {
              case 'shipping':
                this.$store.commit('basket', response.data.basket)
                this.$store.commit('customer', response.data.customer)

                this.shipping.name = this.$store.state.customer.shipping_name
                this.shipping.company_name = this.$store.state.customer.shipping_company_name
                this.shipping.address_1 = this.$store.state.customer.shipping_address_1
                this.shipping.address_2 = this.$store.state.customer.shipping_address_2
                this.shipping.city = this.$store.state.customer.shipping_city
                this.shipping.state = this.$store.state.customer.shipping_state
                this.shipping.country = this.$store.state.customer.shipping_country
                this.shipping.postcode = this.$store.state.customer.shipping_postcode
                this.shipping.source = this.$store.state.customer.source

                this.steps.shipping = true

                this.step = 'billing'

              break;
              case 'billing':
                this.steps.billing = true
                this.step = 'payment'
              break;
            }
          }).catch(error => {
            this.submitting = false

            if (error.response.data.errors) {
              this.errors[this.step] = error.response.data.errors
            } else if (error.response.data.message) {
              this.error = error.response.data.message
            }
          })
      },
      validatePayment() {
        this.submitting = true

        //validate input fields
        if(this.cardData.cardNumber) {
           this.cardData.cardNumber = this.cardData.cardNumber.replace(/\s+/g, '');
        }

        if(this.cardData.expiryDateMonth && this.cardData.expiryDateYear) {
           this.cardData.expiryDate = this.cardData.expiryDateMonth.concat(this.cardData.expiryDateYear);
        }

        const cardHolderNameCheck = RealexRemote.validateCardHolderName(this.cardData.cardName);
        const cardNumberCheck = RealexRemote.validateCardNumber(this.cardData.cardNumber);
        const cardExpiryDateFormatCheck = RealexRemote.validateExpiryDateFormat(this.cardData.expiryDate);
        const cardExpiryDatePastCheck = RealexRemote.validateExpiryDateNotInPast(this.cardData.expiryDate);

        const cvnCheck = RealexRemote.validateCvn(this.cardData.Cvn);
        if(this.cardData.cardNumber && this.cardData.cardNumber.charAt(0) === "3") {
          const cvnCheck = RealexRemote.validateAmexCvn(this.cardData.Cvn);
        }

        if(cvnCheck == false) {
          this.errors.cardData.Cvn = 'The security code format is invalid';
        } else {
          this.errors.cardData.Cvn = null
        }

        if(cardExpiryDateFormatCheck == false || cardExpiryDatePastCheck == false) {
          this.errors.cardData.expiryDate = 'The expiry date needs to be a date in the future and in mm and yy format';
        } else {
          this.errors.cardData.expiryDate = null
        }

        if(cardHolderNameCheck == false) {
          this.errors.cardData.cardName = 'Please enter the cardholders Name';
        } else {
          this.errors.cardData.cardName = null
        }

        if(cardNumberCheck == false) {
          this.errors.cardData.cardNumber = 'Please enter a valid card number';
        } else {
          this.errors.cardData.cardNumber = null
        }

        if(cardHolderNameCheck == false || cardNumberCheck == false || cardExpiryDatePastCheck == false || cardExpiryDateFormatCheck == false || cvnCheck == false) {
          this.cardValidationPassed = false
          this.submitting = false
        } else {
          this.cardValidationPassed = true
        }

        //if all validated send data to payment processing
        if(this.cardValidationPassed) {
           this.payment()
        }
      },
      payment () {
        this.error = null
        this.submitting = true

          axios.post(this.api_uri + '/checkout/payment',  this.cardData )
            .then(response => {
            this.success = response.data.message
            this.submitting = false
            this.complete = true
            this.steps.payment = true
            this.step = 'review'
            sessionStorage.setItem('basket-id', null);
            // gtag('event', 'submit', {
            // event_category: 'Order'
            // })
          }).catch(error => {
            this.submitting = false
            this.error = error.response.data.error || error.message
          })
      },
      goToStep (step) {
        if (!this.complete && this.steps[step]) {
          this.steps[step] = false
          this.step = step
          this.error = null
        }
      },
    }
  }

</script>

<style scoped>
button[disabled="disabled"] {
  opacity: .75;
  cursor: not-allowed;
}

</style>
